module.exports = __webpack_public_path__ + "static/media/vs_code.7c6680d1.png";